// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"154":"0deea6b6","772":"026287af","818":"84374c75","917":"5c24c8a0","991":"36f550c0"}[chunkId] + ".chunk.js";
};